type CallbackFn = () => void;

let active = false;
let pendingCallback: CallbackFn | undefined;
let showModal: (() => void) | undefined;
let hideModal: (() => void) | undefined;
let allowNextRemoval = false;

export const OrderNowLeaveGuard = {
  setActive(value: boolean) {
    active = value;
  },
  isActive() {
    return active;
  },
  intercept(cb: CallbackFn): boolean {
    if (!active || !showModal) {
      return false;
    }
    pendingCallback = cb;
    showModal();
    return true;
  },
  confirm() {
    const cb = pendingCallback;
    pendingCallback = undefined;
    hideModal?.();
    cb?.();
  },
  cancel() {
    pendingCallback = undefined;
    hideModal?.();
  },
  register(show: () => void, hide: () => void) {
    showModal = show;
    hideModal = hide;
  },
  allowNextRemoval() {
    allowNextRemoval = true;
  },
  consumeRemovalBypass() {
    const value = allowNextRemoval;
    allowNextRemoval = false;
    return value;
  },
};

export const shouldConfirmHeaderNavigation = (
  enableJewelryBuilder?: boolean,
  historyLength?: number
) =>
  OrderNowLeaveGuard.isActive() ||
  (!!enableJewelryBuilder && (historyLength ?? 0) > 2);
